import { COMMON } from "../../constants/common";

export const showSnackbar = (message: string, severity: 'error' | 'warning' | 'info' | 'success') => ({
  type: COMMON.SHOW_SNACKBAR,
  payload: { message, severity },
});

export const hideSnackbar = () => ({
  type: COMMON.HIDE_SNACKBAR,
});